module.exports = "https://cdn.thelire.com/ins/resource/crown.55ff69af3a845065de9e54c08f25c9d0.png";